import { Role } from "./roles";

export class User {
    area: string;
    areaId: string;
    dni: string;
    email: string;
    extraDay: any;
    extraHours: number;
    key: string;
    name: string;
    password: string;
    pendingAPs: any;
    pendingHolidays: any;
    petitions: any;
    phone: string;
    repo: string;
    role: Role = Role.unauthorized;
    state: string;
}


// WEBPACK FOOTER //
// ./src/models/user.ts